var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIce(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 64,
    viewBox: "0 0 94 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2090)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.7831 25.1742L81.0737 30.1775L80.3976 30.7709L90.4641 21.9589L85.8966 14.2963L70.4437 8.62449L69.2568 8.18126L68.7459 7.99345L45.2097 3.38086L26.8645 13.3197L7.30231 16.9031L3.38086 30.6132L12.0201 31.5447L13.1169 31.6649L8.04604 31.1165L3.38086 30.6132L11.2163 54.0292L16.9557 54.6527L25.0841 55.5242L25.1742 55.5392L32.1307 56.2829H32.0856L32.3485 56.313L34.5722 56.5534L36.3601 56.7412L46.9225 57.883L49.7697 58.191L52.9925 58.5366L57.53 59.0249L58.1385 59.0925L67.574 60.1067L71.4203 56.7412L78.4143 32.5063L72.3744 53.4357H75.199L78.2791 50.7388L82.6288 46.93L90.4641 21.9589L86.7831 25.1817V25.1742Z",
    fill: "#00E7F9",
    stroke: "#00E7F9",
    strokeWidth: 6.76112,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.38086 30.6123L11.2163 54.0283L8.04604 31.1156L3.38086 30.6123Z",
    fill: "#9BD6EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.782 37.884L60.4074 36.7646L58.1387 59.0914L67.5742 60.1056L72.1042 38.0267L70.782 37.884Z",
    fill: "#BBE4F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8648 33.1508L13.4102 31.6934L16.956 54.6511L16.7006 54.6211L25.1745 55.5376L25.0844 55.5226L26.8648 33.1508Z",
    fill: "#E6F5FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2023 35.1266V57.6938L40.0638 57.1379L42.2274 34.8036L35.1582 34.0449L36.3602 56.7397L34.5723 56.5444L33.9563 33.9096L30.9062 33.5791L32.3411 56.304L32.1308 56.2815L52.9851 58.5352L54.5176 36.1333L45.2023 35.1266ZM46.9151 57.8816L49.0862 35.968L49.7548 58.1896L46.9076 57.8816H46.9151Z",
    fill: "#E6F5FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.0736 30.1768L80.3975 30.7702L81.0736 30.1768Z",
    fill: "#E6F5FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2793 50.7388L82.629 46.9301L90.4643 21.959L86.7833 25.1818L78.2793 50.7388Z",
    fill: "#E6F5FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.9213 35.5634L72.1042 38.0274L67.5742 60.1063L71.4205 56.7407L78.4146 32.5059L74.9213 35.5634Z",
    fill: "#E6F5FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8645 33.1448L30.9062 33.5881L33.9562 33.9111L40.0637 27.4955L35.1581 34.0463L42.2273 34.8051L45.2022 35.1281L54.525 36.1348L60.0316 36.7282L60.4072 36.7658L70.7818 37.8851L72.1039 38.0279L74.9211 35.5638L78.4143 32.5063L72.9754 29.6967L69.8352 30.6132L65.5457 28.6149L70.4437 29.6967L72.9679 28.6149L80.3976 30.7709L90.4641 21.9589L85.8966 14.2963L70.4437 8.62449L66.8077 11.4266L69.2568 8.18126L68.7459 7.99345L45.2097 3.38086L26.8645 13.3197L7.2948 16.9031L3.38086 30.6132L12.0201 31.5447L13.1169 31.6649L13.4099 31.6949L26.8645 33.1448Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4072 36.7646L70.7818 37.884L60.4072 36.7646Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1035 38.0266L74.9207 35.5625L72.1035 38.0266Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0313 36.7273L54.5247 36.1338L52.9922 58.5356L57.5297 59.024L58.1382 59.0916L60.4069 36.7648L60.0313 36.7273Z",
    fill: "#E6F5FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1378 59.092L57.5293 59.0244L58.1378 59.092Z",
    fill: "#E6F5FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.031 36.7273L54.5244 36.1338L60.031 36.7273L60.4066 36.7648L60.031 36.7273Z",
    fill: "#E6F5FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4069 36.7661L60.0312 36.7285L60.4069 36.7661Z",
    fill: "#E6F5FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3409 56.313L30.9061 33.5881L26.8644 33.1523L25.084 55.5242L25.1741 55.5392L32.1306 56.2829H32.0855L32.3409 56.313Z",
    fill: "#BBE4F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.084 55.5234L25.1738 55.5384L25.084 55.5234Z",
    fill: "#BBE4F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.085 56.2822H32.13L32.3404 56.3123L32.085 56.2822Z",
    fill: "#BBE4F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9059 33.5868L26.8643 33.1436V33.1511L30.9059 33.5868Z",
    fill: "#BBE4F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4097 31.6937L13.1167 31.6636L8.0459 31.1152L12.0199 31.5434L8.0459 31.1152L11.2161 54.0279L16.9556 54.6515L13.4097 31.6937Z",
    fill: "#BBE4F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.0459 31.1152L12.0199 31.5434L8.0459 31.1152Z",
    fill: "#BBE4F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4092 31.6941L13.1162 31.6641L13.4092 31.6941Z",
    fill: "#BBE4F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0635 57.1389L45.2019 57.6949V35.1277L42.227 34.8047L40.0635 57.1389Z",
    fill: "#BBE4F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9219 57.8833L49.7691 58.1913L49.0929 35.9697L46.9219 57.8833Z",
    fill: "#BBE4F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5721 56.5452L36.36 56.7405L35.158 34.0457L33.9561 33.918L34.5721 56.5452Z",
    fill: "#9BD6EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0636 27.4951L33.9561 33.9107L35.158 34.0459L40.0636 27.4951Z",
    fill: "#9BD6EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4438 8.62389L69.2568 8.18066L70.4438 8.62389Z",
    fill: "#9BD6EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4436 8.62389L69.2566 8.18066L66.8076 11.426L70.4436 8.62389Z",
    fill: "#9BD6EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7826 25.1729L81.0732 30.1761L86.7826 25.1804V25.1729Z",
    fill: "#BBE4F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.0739 30.1764L80.3978 30.7699L75.1992 53.4347L78.2793 50.7377L86.7833 25.1807L81.0739 30.1764Z",
    fill: "#BBE4F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4141 32.5068L80.3973 30.7715L78.4141 32.5068Z",
    fill: "#9BD6EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.3972 30.7715L78.414 32.5068L72.374 53.4363H75.1987L80.3972 30.7715Z",
    fill: "#9BD6EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.444 29.696L65.5459 28.6143L69.8355 30.6125L72.9756 29.696L78.4146 32.5057L80.3978 30.7703L72.9681 28.6143L70.444 29.696Z",
    fill: "#9BD6EA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2090"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 93.8444,
    height: 63.487,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIce);
export default __webpack_public_path__ + "static/media/ice.svg";
export { ForwardRef as ReactComponent };